'use client'

import { Button, Dialog, Navigation } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'
import { noop } from 'lodash'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import {
  AddressFieldConfiguration,
  AddressFormType,
  AddressModel,
} from '@marketplace-web/address/address-data'

import ShippingAddress from '../ShippingAddress'
import { AddressScreenTrackingType } from '../../constants'

type Props = {
  isOpen: boolean
  address: AddressModel | null | undefined
  translationPrefix: string
  transactionId: number | null | undefined
  addressFormType: AddressFormType
  fieldConfiguration: Array<AddressFieldConfiguration>
  isPending: boolean
  screenTrackingType?: AddressScreenTrackingType
  shippingOrderId?: number | null
  onSubmit: (address: AddressModel) => void
  onClose: () => void
}

const AddressModal = ({
  isOpen,
  address,
  translationPrefix,
  transactionId,
  addressFormType,
  fieldConfiguration,
  isPending,
  screenTrackingType,
  shippingOrderId,
  onSubmit,
  onClose = noop,
}: Props) => {
  const translate = useTranslate(translationPrefix)

  function renderNavigation() {
    return (
      <Navigation
        body={translate('title')}
        right={
          <Button
            inline
            iconName={X24}
            styling="flat"
            onClick={onClose}
            testId="address-modal-navigation-close-button"
          />
        }
      />
    )
  }

  if (!transactionId) return null

  return (
    <Dialog show={isOpen} testId="address-modal">
      {renderNavigation()}
      <ShippingAddress
        address={address}
        transactionId={transactionId}
        addressFormType={addressFormType}
        isPending={isPending}
        fieldConfiguration={fieldConfiguration}
        screenTrackingType={screenTrackingType}
        shippingOrderId={shippingOrderId}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    </Dialog>
  )
}

export default AddressModal
